import { Button, Popover, TextField } from "@material-ui/core";
import React from "react";

const UpdateField = (props) => {
	return (
		<Popover
			id={props.elementId}
			open={props.popOverOpen === props.elementId}
			anchorEl={props.anchorEl}
			onClose={props.handleClose}
			anchorOrigin={{
				vertical: "center",
				horizontal: "center",
			}}
			transformOrigin={{
				vertical: "center",
				horizontal: "center",
			}}
		>
			<div className="p-1">
				<TextField
					id={props.elementId}
					label={props.label}
					type="Number"
					autoComplete={"off"}
					size="small"
					value={props.valorAlterado ? props.valorAlterado : ""}
					onChange={(e) => props.setValorAlterando(e.target.value)}
					autoFocus
				/>
				<div className="mt-1">
					<Button
						className="mr-1"
						variant="contained"
						color="primary"
						size="small"
						onClick={() => props.atualizaPor()}
					>
						Alterar
					</Button>
					<Button
						variant="contained"
						color="secondary"
						size="small"
						onClick={props.handleClose}
					>
						Cancelar
					</Button>
				</div>
			</div>
		</Popover>
	);
};

export default UpdateField;
